<template>
	<v-expansion-panels v-model="panel" flat accordion>
		<ExpansionPanel :title="'Basics'">
			<SettingSwitch
				:title="'Label'"
				:placeholder="'Type your title here'"
				:switchValue.sync="titleEnabled"
				:textFieldValue.sync="titleValue"
			/>
			<div>
				<div class="flex-space-between--center">
					<div class="field-text">Video Settings</div>
					<SIcon :name="'action-info'" class="info-icon" />
				</div>
				<AppSelect
					v-model="streamingServiceSelection"
					item-value="value"
					item-text="text"
					:items="streamingServices"
					class="mt-2"
					outlined
					dense
					placeholder="Select a streaming service"
				/>
				<div class="flex-centerize flex-column mt-2" :class="{ 'is-disabled': !streamingServiceSelection }">
					<CombinedInputFieldDataMenu
						class="width-100"
						:textAreaMode="true"
						:value.sync="videoUrlTextInput"
						:valuesTypes="dataInputMenuValueTypes"
					/>
				</div>
				<div class="soft-message font-size-xs mt-1">The video will fit the maximum width of the form and centered if smaller</div>
			</div>
		</ExpansionPanel>
		<ExpansionPanel :title="'Explanations'">
			<SettingSwitch
				:title="'Description'"
				:placeholder="'Type your description here'"
				:switchValue.sync="descriptionEnabled"
				:textFieldValue.sync="descriptionValue"
			/>
		</ExpansionPanel>
	</v-expansion-panels>
</template>

<script>
import FieldSettingsMixin, { getComputedMetadataOption } from '@/components/BlockEditorWidget/FieldSettings/FieldSettingsMixin';
import ItemOnlyAllowedValueTypesMixin from '@/components/BlockEditorWidget/FieldSettings/ValueTypesMixins/ItemOnlyAllowedValueTypesMixin.js';

import SettingSwitch from '../WidgetSettings/SettingSwitch';
import ExpansionPanel from '../WidgetSettings/ExpansionPanel';

import { STREAMING_SERVICES, STREAMING_SERVICES_TYPES } from './VideoPlayerField.const';
const { YOUTUBE, LOOM, CUSTOM } = STREAMING_SERVICES_TYPES;
export default {
	name: 'VideoPlayerFieldSettings',
	mixins: [FieldSettingsMixin, ItemOnlyAllowedValueTypesMixin],
	components: {
		SettingSwitch,
		ExpansionPanel,
	},
	computed: {
		widgetID() {
			return this.field?.widget;
		},
		videoPlayerSrc: {
			get() {
				return this.localField.metadata.options.video_player_src;
			},
			set(value) {
				let url;
				if (this.streamingServiceType === YOUTUBE) {
					const id = value.split('?')[1].split('v=')[1].split('&')[0];
					url = `https://www.youtube.com/embed/${id}`;
				} else if (this.streamingServiceType === LOOM) {
					const id = value.split('/').pop();
					url = `https://www.loom.com/embed/${id}`;
				} else if (this.streamingServiceType === CUSTOM) {
					url = value;
				}
				this.setLocalFieldKey('metadata.options.video_player_src', url);
			},
		},
		streamingServiceType: getComputedMetadataOption('streaming_service_type'),
	},
	methods: {
		setVideoUrl() {
			this.streamingServiceType = this.streamingServiceSelection;
			this.videoPlayerSrc = this.videoUrlTextInput;
		},
	},
	mounted() {
		this.videoUrlTextInput = this.videoPlayerSrc;
		this.streamingServiceSelection = this.streamingServiceType;
	},
	watch: {
		videoUrlTextInput() {
			this.setVideoUrl();
			this.videoPlayerSrc = this.videoUrlTextInput;
		},
	},
	data() {
		return {
			loading: false,
			imageOption: null,
			videoUrlTextInput: '',
			streamingServiceSelection: null,
			streamingServices: STREAMING_SERVICES,
		};
	},
};
</script>

<style scoped lang="scss"></style>
